<template>
  <div class="md-layout md-gutter md-card-actions">
    <div class="md-layout-item md-toolbar-section-start settings-icon">
      <md-button class="md-icon-button" @click="$emit('setting-click')">
        <md-icon>settings</md-icon>
      </md-button>
    </div>
    <div class="md-layout-item md-toolbar-section-center">
      <div class="fb-title">{{controll}}</div>
    </div>
    <div class="md-layout-item md-toolbar-section-end">
      <md-button
        class="md-icon-button"
        :class="{'md-raised': collapse}"
        @click="collapse = !collapse; $emit('collapse-click')"
      >
        <md-icon>aspect_ratio</md-icon>
      </md-button>
      <md-menu :md-active.sync="menu" :mdCloseOnSelect="closeOnSelect">
        <md-button md-menu-trigger class="md-icon-button">
          <md-icon @click="$emit('menu-click')">more_vert</md-icon>
        </md-button>
        <md-menu-content class="fb-controll-menu">
          <md-menu-item @click="$emit('menu-delete')">Delete</md-menu-item>
        </md-menu-content>
      </md-menu>
    </div>
  </div>
</template>

<script>
export default {
  name: "FbControll",
  props: ["controll"],
  data() {
    return {
      menu: false,
      collapse: false,
      closeOnClick: true,
      closeOnSelect: true
    };
  }
};
</script>

<style lang="scss" scoped>
.md-layout {
  cursor: move; /* fallback if grab cursor is unsupported */
  cursor: grab;
}
.fb-controll-menu {
  z-index: 99;
}
.fb-title {
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0 auto;
}
.settings-icon {

  width: 30%;
  max-width: 100px;
}
</style>
